import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit"
import api from "../api/base"
import tokenSlice from "../state/token"
import step1Slice from "../state/step1"
import step2Slice from "../state/step2"
import step3Slice from "../state/step3"
import step4Slice from "../state/step4"

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    token : tokenSlice,
    step1: step1Slice,
    step2: step2Slice,
    step3: step3Slice,
    step4: step4Slice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
